import { z } from "zod";

import type { AnalyticsTraits } from "@/core/analytics/analytics.types";

type BuildAnalyticsIdentifyPayloadArgs = {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
};

type AnalyticsIdentifyPayload = {
  identifyKey: string;
  traits: AnalyticsTraits;
  userId: string;
};

export function getBrowserTimezone(): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? null;
  } catch {
    return null;
  }
}

export function buildAnalyticsIdentifyPayload({
  email,
  firstName,
  lastName,
  phone,
}: BuildAnalyticsIdentifyPayloadArgs): AnalyticsIdentifyPayload | null {
  const normalizedEmail = email.trim().toLowerCase();

  if (!z.string().email().safeParse(normalizedEmail).success) {
    return null;
  }

  const normalizedFirstName = firstName.trim();
  const normalizedLastName = lastName.trim();
  const normalizedPhone = phone.trim();

  const timezone = getBrowserTimezone();

  return {
    identifyKey: JSON.stringify([
      normalizedEmail,
      normalizedFirstName,
      normalizedLastName,
      normalizedPhone,
    ]),
    traits: {
      email: normalizedEmail,
      ...(timezone ? { timezone } : {}),
      ...(normalizedFirstName ? { firstName: normalizedFirstName } : {}),
      ...(normalizedLastName ? { lastName: normalizedLastName } : {}),
      ...(normalizedPhone ? { phone: normalizedPhone } : {}),
    },
    userId: normalizedEmail,
  };
}
